import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class CIBC_DOCUMENTS_HOME_POWER_PLAN_ID_VERIFICATION_Mapper extends BaseFormMapper<CIBC_DOCUMENTS_HOME_POWER_PLAN_ID_VERIFICATION> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: CIBC_DOCUMENTS_HOME_POWER_PLAN_ID_VERIFICATION,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as CIBC_DOCUMENTS_HOME_POWER_PLAN_ID_VERIFICATION);

		return _formData;
	}

	MapValues(): Partial<CIBC_DOCUMENTS_HOME_POWER_PLAN_ID_VERIFICATION> {
		return {};
	}
}

const Mappings: CIBC_DOCUMENTS_HOME_POWER_PLAN_ID_VERIFICATION = {
	// "0":"topmostSubform[0]",
	// "1":"topmostSubform[0].Page3[0]",
	solictorName: 'topmostSubform[0].Page3[0].NAME_SOLICITOR[0]',
	signatureDate: 'topmostSubform[0].Page3[0].SIGNATURE_DATE[0]',
	description2: 'topmostSubform[0].Page3[0].DESCRIPTION_CLIENT_PRODUCTS_2[0]',
	electronicVersion2:
		'topmostSubform[0].Page3[0].SOURCE_ELECTRONIC_VERSION_2[0]',
	typeOfRecord2: 'topmostSubform[0].Page3[0].TYPE_RECORD_REFERRED_2[0]',
	registrationNumber2: 'topmostSubform[0].Page3[0].REGISTRATION_NUMBER_2[0]',
	typeOfEntity2: 'topmostSubform[0].Page3[0].TYPE_ENTITY_2[0]',
	corporationName2: 'topmostSubform[0].Page3[0].NAME_CORPORATION_2[0]',
	description: 'topmostSubform[0].Page3[0].DESCRIPTION_CLIENT_PRODUCTS_1[0]',
	electronicVersion:
		'topmostSubform[0].Page3[0].SOURCE_ELECTRONIC_VERSION_1[0]',
	typeOfRecord: 'topmostSubform[0].Page3[0].TYPE_RECORD_REFERRED_1[0]',
	registrationNumber: 'topmostSubform[0].Page3[0].REGISTRATION_NUMBER_1[0]',
	typeOfEntity: 'topmostSubform[0].Page3[0].TYPE_ENTITY_1[0]',
	corporationName: 'topmostSubform[0].Page3[0].NAME_CORPORATION_1[0]',
	// "16":"topmostSubform[0].Page2[0]",
	countryB3: 'topmostSubform[0].Page2[0].COUNTRY_AB3[0]',
	jurisdictionB3: 'topmostSubform[0].Page2[0].JURISDICTION_AB3[0]',
	expiryDateB3: 'topmostSubform[0].Page2[0].EXPIRY_DATE_AB3[0]',
	numberB3: 'topmostSubform[0].Page2[0].NUMBER_AB3[0]',
	typeB3: 'topmostSubform[0].Page2[0].TYPE_AB3[0]',
	countryA3: 'topmostSubform[0].Page2[0].COUNTRY_A3[0]',
	jurisdictionA3: 'topmostSubform[0].Page2[0].JURISDICTION_A3[0]',
	expiryDateA3: 'topmostSubform[0].Page2[0].EXPIRY_DATE_A3[0]',
	numberA3: 'topmostSubform[0].Page2[0].NUMBER_A3[0]',
	typeA3: 'topmostSubform[0].Page2[0].TYPE_A3[0]',
	borrowers3: 'topmostSubform[0].Page2[0].FULL_NAME_3[0]',
	countryB2: 'topmostSubform[0].Page2[0].COUNTRY_AB2[0]',
	jurisdictionB2: 'topmostSubform[0].Page2[0].JURISDICTION_AB2[0]',
	expiryDateB2: 'topmostSubform[0].Page2[0].EXPIRY_DATE_AB2[0]',
	numberB2: 'topmostSubform[0].Page2[0].NUMBER_AB2[0]',
	typeB2: 'topmostSubform[0].Page2[0].TYPE_AB2[0]',
	countryA2: 'topmostSubform[0].Page2[0].COUNTRY_A2[0]',
	jurisdictionA2: 'topmostSubform[0].Page2[0].JURISDICTION_A2[0]',
	expiryDateA2: 'topmostSubform[0].Page2[0].EXPIRY_DATE_A2[0]',
	numberA2: 'topmostSubform[0].Page2[0].NUMBER_A2[0]',
	typeA2: 'topmostSubform[0].Page2[0].TYPE_A2[0]',
	borrowers2: 'topmostSubform[0].Page2[0].FULL_NAME_2[0]',
	countryB: 'topmostSubform[0].Page2[0].COUNTRY_AB1[0]',
	jurisdictionB: 'topmostSubform[0].Page2[0].JURISDICTION_AB1[0]',
	expiryDateB: 'topmostSubform[0].Page2[0].EXPIRY_DATE_AB1[0]',
	numberB: 'topmostSubform[0].Page2[0].NUMBER_AB1[0]',
	typeB: 'topmostSubform[0].Page2[0].TYPE_AB1[0]',
	countryA: 'topmostSubform[0].Page2[0].COUNTRY_A1[0]',
	jurisdictionA: 'topmostSubform[0].Page2[0].JURISDICTION_A1[0]',
	expiryDateA: 'topmostSubform[0].Page2[0].EXPIRY_DATE_A1[0]',
	numberA: 'topmostSubform[0].Page2[0].NUMBER_A1[0]',
	typeA: 'topmostSubform[0].Page2[0].TYPE_A1[0]',
	borrowers1: 'topmostSubform[0].Page2[0].FULL_NAME_1[0]',
	propertyAddress: 'topmostSubform[0].Page2[0].ADR_PROP1_RUE[0]',
	mortgageLoanNumber: 'topmostSubform[0].Page2[0].ID_PRET_CLIENT[0]',
	// "52":"topmostSubform[0].Page2[0].BARCODE_FAX_RETURN_LENDER[0]"
};

export interface CIBC_DOCUMENTS_HOME_POWER_PLAN_ID_VERIFICATION {
	mortgageLoanNumber: string;
	propertyAddress: string;

	borrowers1: string;

	typeA: string;
	numberA: string;
	expiryDateA: string;
	jurisdictionA: string;
	countryA: string;

	typeB: string;
	numberB: string;
	expiryDateB: string;
	jurisdictionB: string;
	countryB: string;

	borrowers2: string;

	typeA2: string;
	numberA2: string;
	expiryDateA2: string;
	jurisdictionA2: string;
	countryA2: string;

	typeB2: string;
	numberB2: string;
	expiryDateB2: string;
	jurisdictionB2: string;
	countryB2: string;

	borrowers3: string;

	typeA3: string;
	numberA3: string;
	expiryDateA3: string;
	jurisdictionA3: string;
	countryA3: string;

	typeB3: string;
	numberB3: string;
	expiryDateB3: string;
	jurisdictionB3: string;
	countryB3: string;

	corporationName: string;
	typeOfEntity: string;
	registrationNumber: string;
	typeOfRecord: string;
	electronicVersion: string;
	description: string;

	corporationName2: string;
	typeOfEntity2: string;
	registrationNumber2: string;
	typeOfRecord2: string;
	electronicVersion2: string;
	description2: string;

	signatureDate: string;
	solictorName: string;
}
